var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-tile-macro.j2"] = require( "macros/product-tile-macro.j2" );
dependencies["macros/contentful-module-spacing.j2"] = require( "macros/contentful-module-spacing.j2" );
dependencies["macros/utils.j2"] = require( "macros/utils.j2" );
dependencies["contentful/recommendations-container.j2"] = require( "contentful/recommendations-container.j2" );
dependencies["contentful/product-tray-module-content.j2"] = require( "contentful/product-tray-module-content.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/contentful/product-tray-module.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-tile-macro.j2", false, "core/templates/macros/contentful/product-tray-module.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayProductTile")) {
var t_4 = t_1.displayProductTile;
} else {
cb(new Error("cannot import 'displayProductTile'")); return;
}
context.setVariable("displayProductTile", t_4);
env.getTemplate("macros/contentful-module-spacing.j2", false, "core/templates/macros/contentful/product-tray-module.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("calculateModuleSpacing")) {
var t_8 = t_5.calculateModuleSpacing;
} else {
cb(new Error("cannot import 'calculateModuleSpacing'")); return;
}
context.setVariable("calculateModuleSpacing", t_8);
env.getTemplate("macros/utils.j2", false, "core/templates/macros/contentful/product-tray-module.j2", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
t_9.getExported(function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
if(t_9.hasOwnProperty("create_attr")) {
var t_12 = t_9.create_attr;
} else {
cb(new Error("cannot import 'create_attr'")); return;
}
context.setVariable("create_attr", t_12);
var macro_t_13 = runtime.makeMacro(
[], 
["entry", "moduleIndex", "isSpecialtyShop", "isLazy", "entryloop"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("entry", kwargs.hasOwnProperty("entry") ? kwargs["entry"] : {});
frame.set("moduleIndex", kwargs.hasOwnProperty("moduleIndex") ? kwargs["moduleIndex"] : 0);
frame.set("isSpecialtyShop", kwargs.hasOwnProperty("isSpecialtyShop") ? kwargs["isSpecialtyShop"] : false);
frame.set("isLazy", kwargs.hasOwnProperty("isLazy") ? kwargs["isLazy"] : false);
frame.set("entryloop", kwargs.hasOwnProperty("entryloop") ? kwargs["entryloop"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_14 = "";var t_15;
t_15 = runtime.contextOrFrameLookup(context, frame, "entry");
frame.set("module", t_15, true);
if(frame.topLevel) {
context.setVariable("module", t_15);
}
if(frame.topLevel) {
context.addExport("module", t_15);
}
t_14 += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "isSpecialtyShop")) {
t_14 += "\n        ";
var t_16;
t_16 = "s-product-tray s-specialty-shop-tray js-slider-specialty-shop-tray";
frame.set("productTrayClass", t_16, true);
if(frame.topLevel) {
context.setVariable("productTrayClass", t_16);
}
if(frame.topLevel) {
context.addExport("productTrayClass", t_16);
}
t_14 += "\n        ";
var t_17;
t_17 = "";
frame.set("productTrayWrapperClass", t_17, true);
if(frame.topLevel) {
context.setVariable("productTrayWrapperClass", t_17);
}
if(frame.topLevel) {
context.addExport("productTrayWrapperClass", t_17);
}
t_14 += "\n    ";
;
}
else {
t_14 += "\n        ";
var t_18;
t_18 = "s-product-tray js-slider-product-tray";
frame.set("productTrayClass", t_18, true);
if(frame.topLevel) {
context.setVariable("productTrayClass", t_18);
}
if(frame.topLevel) {
context.addExport("productTrayClass", t_18);
}
t_14 += "\n        ";
var t_19;
t_19 = env.getFilter("trim").call(context, (lineno = 12, colno = 61, runtime.callWrap(t_8, "calculateModuleSpacing", context, [runtime.contextOrFrameLookup(context, frame, "module"),runtime.contextOrFrameLookup(context, frame, "moduleIndex"),1])));
frame.set("productTrayWrapperClass", t_19, true);
if(frame.topLevel) {
context.setVariable("productTrayWrapperClass", t_19);
}
if(frame.topLevel) {
context.addExport("productTrayWrapperClass", t_19);
}
t_14 += "\n    ";
;
}
t_14 += "\n\n    <div class=\"";
t_14 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productTrayWrapperClass"), env.opts.autoescape);
t_14 += "\">\n\n        <div class=\"";
t_14 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productTrayClass"), env.opts.autoescape);
t_14 += "\" data-qa-product-tray>\n\n            ";
var t_20;
t_20 = (lineno = 19, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.tray"]));
frame.set("tray", t_20, true);
if(frame.topLevel) {
context.setVariable("tray", t_20);
}
if(frame.topLevel) {
context.addExport("tray", t_20);
}
t_14 += "\n            ";
var t_21;
t_21 = (lineno = 20, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.source"]));
frame.set("source", t_21, true);
if(frame.topLevel) {
context.setVariable("source", t_21);
}
if(frame.topLevel) {
context.addExport("source", t_21);
}
t_14 += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "source") == "Dynamic Yield") {
t_14 += "\n\n                ";
env.getTemplate("contentful/recommendations-container.j2", false, "core/templates/macros/contentful/product-tray-module.j2", null, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
t_22.render(context.getVariables(), frame, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
t_14 += t_23
t_14 += "\n\n            ";
})});
}
else {
t_14 += "\n\n                <div class=\"c-product-tray dom-product-tray-content\"\n                    data-index=\"";
t_14 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "moduleIndex"), env.opts.autoescape);
t_14 += "\">\n\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "tray") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tray")),"records")) {
t_14 += "\n\n                        ";
env.getTemplate("contentful/product-tray-module-content.j2", false, "core/templates/macros/contentful/product-tray-module.j2", null, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
t_26.render(context.getVariables(), frame, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_14 += t_27
t_14 += "\n\n                    ";
})});
}
t_14 += "\n\n                </div>\n\n            ";
;
}
t_14 += "\n\n        </div>\n\n    </div>";
;
frame = frame.pop();
return new runtime.SafeString(t_14);
});
context.addExport("productTrayModule");
context.setVariable("productTrayModule", macro_t_13);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/contentful/product-tray-module.j2"] , dependencies)